import { Table as AntdTable } from 'antd';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { ConfigProvider } from 'antd';
import { useSelector } from 'react-redux';
import React, { useState, useEffect } from 'react';
import '../../../../cssfiles/homepage.css';

export default function AccordionTable(props) {
    const tagcollectionvalue = useSelector((state) => state.mainpagedata.tagcollectionvalues);
    const sdateEdateSelected = useSelector((state) => state.mainpagedata.selecteddates);

    const [tree, setTree] = useState([]);

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Consumed',
            dataIndex: 'consumed',
            key: 'consumed',
            width: '24%',
        },
        {
            title: 'Losses',
            dataIndex: 'losses',
            width: '24%',
            key: 'losses',
        },
    ];

    // Function to build the tree structure from linkage collection
    function buildTree(linkage_collection) {
        const tree = [];
        const nodeMap = new Map();
        let keyval = 1; // Move keyval inside the function to avoid side effects

        function addNode(nodeKey, parentKey = '') {
            const node = linkage_collection[nodeKey];
            if (!node) return null;

            const newNode = {
                key: nodeKey, // Use nodeKey directly for unique key
                name: nodeKey,
                consumed: node.associated_value.toFixed(2),
                losses: node.losses_children === 'NA' ? 'NA' : (node.losses_children || 0).toFixed(2),
                children: node.children.map((childKey) => addNode(childKey, nodeKey)).filter(child => child !== null),
            };
            nodeMap.set(nodeKey, newNode); // Store node in map
            return newNode;
        }

        for (let key in linkage_collection) {
            if (linkage_collection[key].parent === '') {
                tree.push(addNode(key));
            }
        }

        return tree;
    }

    useEffect(()=>{

    },[tree])

    // useEffect to update the tree data whenever dependencies change
    console.log("tagcollectionvalue[linkageObject] in ant d table-",tagcollectionvalue["linkageObject"])
    useEffect(() => {
        const linkage_collection_copy = structuredClone(tagcollectionvalue["linkageObject"]);
        const updatedTree = buildTree(linkage_collection_copy);
        setTree(updatedTree);
    }, [props.widgetprop.widgetname, tagcollectionvalue]);

    return (
        <ConfigProvider
            theme={{
                token: {
                    borderRadius: 0,
                    colorText: 'var(--grey-variation-tablerowsLK)',
                    colorTextHeading: 'var(--grey-variation-tablerowsLK)',
                    fontFamily: props.widgetprop.props.extended.tablerows.fonttype,
                    fontSizeIcon: 10,
                    colorBgContainer: 'var(--secondary-backgroundLK)',
                    lineHeight: 1.5,
                },
                components: {
                    Table: {
                        borderColor: 'var(--table-boarder-line)',
                        headerBg: 'var(--secondary-backgroundLK)',
                        headerSplitColor: '#EDEFEE',
                        rowHoverBg: 'var(--primary-background-color-hover)',
                        stickyScrollBarBg: 'var(--primary-background-color),var(--secondary-background)',
                        stickyScrollBarBorderRadius: 0,
                        cellFontSizeSM: props.widgetprop.props.extended.tablerows.fontsize,
                        cellPaddingBlockSM: '7.05px',
                        cellPaddingInlineSM: '7.1px',
                    },
                },
            }}
        >
            <AntdTable
                bordered={false}
                columns={columns}
                rowSelection={false}
                dataSource={tree}
                size='small'
                pagination={false}
                scroll={{ y: "190px" }}
                style={{
                    marginLeft: "2px",
                    marginRight: "2px",
                    marginTop: 0,
                    marginBottom: 0,
                    height: "200px",
                    width: "99%",
                    backgroundColor:'var(--secondary-backgroundLK)',
                }}
                expandable={{
                    defaultExpandedRowKeys: tree.map(node => node.key), // Expand all rows by default
                    indentSize: 15,
                    expandIcon: ({ expanded, onExpand, record }) =>
                        record.children && record.children.length > 0 ? (
                            expanded ? (
                                <ExpandMoreIcon sx={{ width: 10, height: 10, color: '#C2CBC8' }} onClick={e => onExpand(record, e)} />
                            ) : (
                                <ChevronRightIcon sx={{ width: 10, height: 10, color: '#C2CBC8' }} onClick={e => onExpand(record, e)} />
                            )
                        ) : null,
                }}
            />
        </ConfigProvider>
    );
}
